export default __webpack_public_path__ + "static/media/Asset 10.f75993e1.svg";